const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Pie Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8 2.40002V11.2H21.6C21.6 6.34002 17.66 2.40002 12.8 2.40002ZM11.2 4.00002C6.33999 4.00002 2.39999 7.94002 2.39999 12.8C2.39999 17.66 6.33999 21.6 11.2 21.6C16.06 21.6 20 17.66 20 12.8H11.2V4.00002Z",
    fill: "#35C0FC",
    style: {
      fill: "#35C0FC",
      fill: "color(display-p3 0.2078 0.7529 0.9882)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPieChart);
export default __webpack_public_path__ + "static/media/icon-pie-chart.0df9a6a3db1afe5c38a49d68db1586673219506daee4a5e486ec2e524ceebe40.svg";
export { ForwardRef as ReactComponent };